import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { IssueTaskDoc, IssueTaskStatus } from '@gooduncles/gu-app-schema';
import { Button, Popconfirm, message, notification } from 'antd';
import { FC } from 'react';
import { useAuth } from 'src/stores/auth-context';

import { deleteIssueTask, updateIssueTask } from 'src/utils/firebase/firebase-short-cut';

interface IssueTaskHeaderButtonsProps {
  issueTaskDoc: IssueTaskDoc;
}

const IssueTaskHeaderButtons: FC<IssueTaskHeaderButtonsProps> = ({ issueTaskDoc }) => {
  const { user } = useAuth();
  const deletable = issueTaskDoc.status < IssueTaskStatus.IN_PROGRESS;

  const onDeleteIssueTask = async (issueTaskId: string) => {
    if (!user) {
      message.error('사용자 정보가 없습니다. 다시 로그인 해주세요.');
      return;
    }
    try {
      if (!deletable) {
        message.error('처리 중인 이슈 태스크는 삭제할 수 없습니다.');
        return;
      }
      await deleteIssueTask(issueTaskId);
      message.success('이슈 태스크가 삭제되었습니다.');
    } catch (error) {
      console.error(error);
      notification.error({ message: '이슈 태스크 삭제에 실패했습니다. 다시 시도해주세요.' });
    }
  };

  const onUpdateIssueTaskStatus = async (status: IssueTaskStatus) => {
    await updateIssueTask(issueTaskDoc._id, { status });
  };

  return (
    <div className='flexRow flexAlignCenter'>
      <Popconfirm
        title='삭제하시겠습니까?'
        onConfirm={() => onDeleteIssueTask(issueTaskDoc._id)}
        okText='삭제'
        okButtonProps={{ danger: true, disabled: !deletable }}
        cancelText='취소'>
        <Button type='default' size='small' danger disabled={!deletable}>
          삭제
        </Button>
      </Popconfirm>
      {issueTaskDoc.status === IssueTaskStatus.PENDING ? (
        <Button
          type='primary'
          size='small'
          icon={<CheckOutlined />}
          onClick={() => onUpdateIssueTaskStatus(IssueTaskStatus.OPEN)}>
          등록
        </Button>
      ) : (
        <Button
          size='small'
          icon={<CloseOutlined />}
          disabled={issueTaskDoc.status !== IssueTaskStatus.OPEN}
          onClick={() => onUpdateIssueTaskStatus(IssueTaskStatus.PENDING)}>
          등록 취소
        </Button>
      )}
    </div>
  );
};

export default IssueTaskHeaderButtons;
